export const PassValidator = value => {
    const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>+'-/:;=_~`[\]\\])[A-Za-z\d!@#$%^&*(),.?":{}|<>+'-/:;=_~`[\]\\]{10,128}$/;
    const identicalCharCheck = /(.)\1{2,}/;
    if (!regex.test(value)) {
        return false;
    }
    if (identicalCharCheck.test(value)) {
        return false;
    }
    return true;
};

// but can accept special characters
export const PassValidatorWithoutSpecial = value => {
    const regex = /(?=[A-Za-z0-9!@._*#%)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$/;
    return regex.test(value);
};
